import { Dropdown, Menu, Modal, Switch, Table } from "antd";
import Header from "../../../components/HeaderList";
import { getColumnSearchProps } from "../../../utils/tables";
import { ReactComponent as MoreDetail } from "../../../assets/icons/more-detail.svg";
import CategoryEditor from "./Editor";
import styles from "../styles/CategoriesUI.module.css";

const CategoriesUI = ({
  loading,
  categories,
  visibleEditor,
  selectedCategory,
  openEditor,
  closeEditor,
  handleStatusChange,
  handleSave,
}) => {
  const getOptions = (record) => (
    <Menu>
      <Menu.Item onClick={() => openEditor(record)}>Editar imágenes</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "ID Categoría",
      dataIndex: "id",
      align: "center",
      ...getColumnSearchProps("id"),
      sorter: (a, b) => Number(a.id || 0) - Number(b.id || 0),
    },
    {
      title: "Imagen",
      dataIndex: "cf_image_icon2",
      align: "center",
      render: (value, record) => (
        <div className={styles.imageCell}>
          {value ? (
            <img
              src={value}
              alt={record.name}
              className={styles.imagePreview}
            />
          ) : (
            <span className={styles.imagePlaceholder}>Sin imagen</span>
          )}
        </div>
      ),
    },
    {
      title: "Cantidad",
      dataIndex: "qty",
      align: "center",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Activo",
      dataIndex: "active",
      align: "center",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => Number(record.active) === Number(value),
      sorter: (a, b) => Number(a.active || 0) - Number(b.active || 0),
      render: (value, record) => (
        <Switch
          checked={Boolean(value)}
          onChange={() => handleStatusChange(record.id, value, "active")}
        />
      ),
    },
    {
      title: "Acciones",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <Dropdown overlay={getOptions(record)} trigger={["click"]}>
          <button type="button" className={styles.menuButton}>
            <MoreDetail />
          </button>
        </Dropdown>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header title="Categorías" back="/productos" />
      <Modal
        destroyOnClose
        wrapClassName={styles.modal}
        footer={false}
        visible={visibleEditor}
        width={720}
        closable={false}
        onCancel={closeEditor}
      >
        <CategoryEditor
          category={selectedCategory}
          closeEditor={closeEditor}
          handleSave={handleSave}
        />
      </Modal>
      <Table columns={columns} dataSource={categories} rowKey="id" loading={loading} />
    </div>
  );
};

export default CategoriesUI;
